import {
  Component,
  OnInit,
  OnDestroy,
  EventEmitter,
  Input,
  ElementRef, ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {CatalogQuestionModel} from "../../../../core/services/catalog-data/catalog-question.model";
import {CatalogDataService} from "../../../../core/services/catalog-data/catalog-data.service";
import {DialogComponent} from "@syncfusion/ej2-angular-popups";
import {QuestionOverlayService} from "../../services/question-overlay/question-overlay.service";
import {
  CatalogQuestionWithSectionModel
} from "../../../../core/services/catalog-data/catalog-question-with-section.model";
import {ButtonPropsModel} from "@syncfusion/ej2-popups/src/dialog/dialog-model";
import {$translate} from "../../../../core/services/internationalization/localize.service";
import {CatalogDataModel} from "../../../../core/services/catalog-data/catalog-data.model";

@Component({
  selector: 'sb-question-overlay',
  templateUrl: './question-overlay.component.html',
  styleUrls: ['./question-overlay.component.scss']
})
export class QuestionOverlayComponent implements OnInit, OnDestroy {
  @ViewChild('ejDialog', {static: false}) ejDialog: DialogComponent;

  @Input()
  recordId: string;

  @Input()
  recordTable: string;

  @Input()
  resolve: (val: any) => void;

  item: CatalogDataModel;

  allQuestions: CatalogQuestionModel[] = [];

  questions: CatalogQuestionModel[] = [];

  questionsWithSections: CatalogQuestionWithSectionModel[];

  subscription: Subscription;

  visible = false;

  buttons: ButtonPropsModel[] = [
    {
      'click': () => { this.ejDialog.hide() },
      buttonModel: {
        content: $translate("common.button.close")`Close`,
        isPrimary: true,
      }
    },
  ];

  constructor(private host: ElementRef,
              private catalogDataService: CatalogDataService,
              private questionOverlayService: QuestionOverlayService,
              private router: Router) {
    this.host.nativeElement.show = this.showDialog.bind(this);
    this.host.nativeElement.hide = this.hideDialog.bind(this);
  }

  async ngOnInit() {

    const answers: any = await this.catalogDataService.getAllAnswers(this.recordId, this.recordTable);

    if (answers.found) {
      const catalogItemId = answers.catalogItemId;
      const questions: CatalogQuestionModel[] = await this.catalogDataService.getAllQuestions(catalogItemId);

      this.allQuestions = questions;
      this.item = await this.catalogDataService.getQuestionItemById(catalogItemId);

      const questionIdToQuestion = {};
      questions.forEach((q) => {
        questionIdToQuestion[q.id] = q;
      });

      this.questions = answers.questions.map((a) => {
        const question = questionIdToQuestion[a.questionId];
        question.data = a;
        question.readonly = true;
        question.mandatory = false;
        question.enablePreview = false;
        question.requestId = this.recordId;
        question.table = this.recordTable;
        question.changed = new EventEmitter<CatalogQuestionModel>();
        question.changedDefault = new EventEmitter<CatalogQuestionModel>();
        return question;
      });

      this.groupQuestionsBySection();

      this.subscription = this.router.events.subscribe((e) => {
          this.removeElement();
      });

    }
  }

  ngOnDestroy(): void {
    this.subscription && this.subscription.unsubscribe();
    this.questionOverlayService.deregisterModal(this.recordId, this.recordTable);
  }

  showDialog() {
    this.visible = true;
  }

  hideDialog() {
    this.visible = false;
    this.doResolve(true);
    this.removeElement();
  }

  onClose($event: any) {
    this.doResolve(true);
    this.removeElement();
  }

  removeElement() {
    this.host.nativeElement.remove();
  }

  doResolve(val) {
    this.resolve && this.resolve(val);
  }

  groupQuestionsBySection() {
    let currentSection: CatalogQuestionWithSectionModel = { header: null, alternateColumnCountInSection: false, questions: [] };
    let sections = [currentSection];

    // Group all questions into their sections - this is so that sections still exist even if the
    // first question is not there.
    this.allQuestions.forEach((q, idx) => {
      if (q.localizedSectionTitle || q.sectionTitle) {
        // If we have another section header then open a new section
        currentSection = { header: (q.localizedSectionTitle || q.sectionTitle), alternateColumnCountInSection: q.alternateColumnCountInSection, questions: [q] };
        sections.push(currentSection);
      } else {
        // Add to current section
        currentSection.questions.push(q);
      }

      // If we are told to close the section then add a new empty one
      if (q.closeSectionAfter) {
        currentSection = { header: null, alternateColumnCountInSection: false, questions: [] };
        sections.push(currentSection);
      }
    });

    // Remove questions that are not to be displayed and sections that are empty
    sections = sections.map((section, idx) => {
      section.questions = section.questions.map(sq => {
        return this.questions.find(q => q.id == sq.id && !q.backgroundOnly);
      })
        .filter( s => !!s);
      return section.questions.length > 0 ? section : null;
    }).filter( s => !!s);

    this.questionsWithSections = sections;
  }

  columnClass(alternateColumnCountInSection: boolean): string {
    const columnCount = this.item.twoColumns ? (alternateColumnCountInSection ? 1 :  2) : (alternateColumnCountInSection ? 2 : 1);
    return columnCount == 2 ? "quick-layout-half-width" : "quick-layout-full-width";
  }

  customContainerClass(question: CatalogQuestionModel): string {
    return question?.rendererProperties?.['compact'] == 'true' ? 'l-compact' : '';
  }

}
